import { Navigate, Route, Routes } from 'react-router-dom';
import { Activation } from './pages/Activation';
import { ForgotPassword } from './pages/ForgotPassword';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ResetPassword } from './pages/ResetPassword';
import { ChangeEmail } from './pages/ChangeEmail';
import { NonMarshallReddickOnlyGuard } from './auth/NonMarshallReddickOnlyGuard';
import { ChangeEmailConfirm } from './pages/ChangeEmailConfirm';

function App() {
  return (
    <Routes>
      <Route index element={<Navigate to="/login" replace />} />

      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="activate-account" element={<Activation />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="change-email-confirm" element={<ChangeEmailConfirm />} />

      <Route element={<NonMarshallReddickOnlyGuard />}>
        <Route path="change-email" element={<ChangeEmail />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
